import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { isAfter, startOfDay } from 'date-fns';
import { useFieldArray, useForm } from 'react-hook-form';
import { BillMode } from '~/components/BillClientModal/BillClientModal.types';
import { createEmptyChargeItem } from '~/components/BillClientModal/v2/shared/Lines/lineItem.utils';
import { useIoContext } from '~/contexts';
import { AD_HOC_PAYMENT_DEFAULTS } from '../AdHocBillModal.types';
export const useAdHocBillForm = (param)=>{
    let { defaultEmailSubject, defaultEmailContent } = param;
    const { getNow } = useIoContext();
    const now = getNow();
    const form = useForm({
        mode: 'onSubmit',
        defaultValues: _object_spread_props(_object_spread({
            mode: BillMode.Now,
            issueDate: now,
            items: [
                createEmptyChargeItem()
            ]
        }, AD_HOC_PAYMENT_DEFAULTS), {
            emailSubject: defaultEmailSubject,
            emailContent: defaultEmailContent
        })
    });
    const items = useFieldArray({
        control: form.control,
        name: 'items'
    });
    const issueDate = form.watch('issueDate');
    const isFutureIssueDate = isAfter(startOfDay(issueDate), startOfDay(now));
    return _object_spread_props(_object_spread({}, form), {
        items,
        now,
        isFutureIssueDate
    });
};
